import React from "react";
import "../assets/styles/HomePage.css";



function TermsOfUse() {
  return (
  <>
    

    <div className="home-page">    
      <div className="recommended-use-cases">
        <h1>Terms of Use📜</h1>
        <p><strong> Updated: 01.03.2025 </strong></p>
        <p>
          Welcome to download-videos ("Platform," "we," "our," or "us"). By signing up and using our services, you agree to abide by these Terms of Use ("Terms"). 
          Please read them carefully.
        </p>
        <h2>1. Acceptance of Terms✅</h2>
        <p>
          By accessing or using our Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not use the Platform.❌
        </p>
        <h2>2. Description of Services🎙️</h2>
        <p>
          Our Platform allows users to download videos from any freely available platform. The user can convert videos into various resolutions and into audio only format as well.
        </p>

        <h2>3. User Responsibilities⚖️</h2>
        <p>
          By using the Platform, you agree that you will:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Use the Platform only for lawful purposes and not violate any local, national, or international laws.</li>
            <li>Not upload, share, or process content that infringes on the rights of others, including copyright, trademarks, or other intellectual property. 🚫</li>
            <li>Not engage in fraudulent, harmful, or unauthorized activities, including but not limited to automated data extraction, hacking, or any action that disrupts the normal operation of the Platform. 🛑</li>
          </ul>
        </p>          

        <h2>4. Content Ownership and Rights 🎤</h2>
        <p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Users retain ownership of any transcripts they generate using the Platform. ✍️</li>
            <li>By using the Platform, you grant us a limited, non-exclusive license to process your uploaded content solely for the purpose of providing our transcription services. 🔄</li>
            <li>We do not claim ownership of any user-generated content. 📂</li>
          </ul>
        </p>          


        <h2>5. Service Modifications and Termination 🔄</h2>
        <p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>We reserve the right to modify, suspend, or discontinue the Platform at any time without prior notice. 🚧</li>
            <li>We may terminate or suspend user accounts that violate these Terms or engage in unauthorized use of the Platform. 🚫</li>
          </ul>
        </p>          

        <h2>6. Disclaimer of Warranties ⚠️</h2>
        <p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>The Platform is provided "as is" and "as available." We make no warranties, expressed or implied, regarding reliability, accuracy, or availability. ⚖️</li>
            <li>We do not guarantee that the Platform will be error-free, uninterrupted, or secure. ❌</li>
          </ul>
        </p>          

        <h2>7. Limitation of Liability ⚠️</h2>
        <p>
          To the fullest extent permitted by law, we shall not be liable for any direct, indirect, incidental, or consequential damages arising from:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> The use or inability to use the Platform. ❌</li>
            <li> Unauthorized access to user data. 🔓</li>
            <li>Errors or inaccuracies in transcription results. 🎙️</li>
          </ul>
        </p>          


        <h2>8. Changes to Terms 🔄</h2>
        <p>
          We reserve the right to modify these Terms at any time. Updated Terms will be posted on this page, and continued use of the Platform signifies acceptance of the revised Terms. 📜
        </p>  

        <h2>9. Contact Information 📧</h2>
        <p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>For any questions regarding these Terms, please contact us <a style={{textDecoration: "none", color: "#f1c40f"}} href="https://chaperoneai.net/contact" target="_blank" rel="noopener noreferrer"> here</a>. 📩</li>
            <li>By using our Platform, you confirm that you have read, understood, and agreed to these Terms of Use. ✅</li>
          </ul>
        </p>
        

      </div>
    </div>
    </>
  );
}

export default TermsOfUse;
